"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var ErrorPanel_1 = __importDefault(require("../../components/globals/ErrorPanel"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var EkycHoujinProxyTop = /** @class */ (function (_super) {
    __extends(EkycHoujinProxyTop, _super);
    function EkycHoujinProxyTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultColXl = 9;
        _this.defaultColLd = 9;
        _this.defaultColMd = 9;
        _this.defaultColSm = 11;
        _this.defaultColXs = 11;
        _this.email = "";
        _this.hasError = false;
        _this.complete = false;
        _this.loading = false;
        _this.alreadySubmitFlag = false;
        _this.defaultErrorFlag = true;
        _this.approvedFlag = false;
        return _this;
    }
    EkycHoujinProxyTop.prototype.data = function () {
        return {
            alreadySubmitFlag: false,
            defaultErrorFlag: true,
            approvedFlag: false,
        };
    };
    EkycHoujinProxyTop.prototype.refs = function () {
        return this.$refs;
    };
    EkycHoujinProxyTop.prototype.getMessage = function (errors) {
        if (errors.length) {
            return this.$t('view.contract_form.confirm_email.messages.error.email');
        }
        return "";
    };
    EkycHoujinProxyTop.prototype.mounted = function () {
        this.$emit('title-change', '');
        //パラメータを取得
        var submitFlag = this.$route.query.submitFlag;
        if (submitFlag && value_checker_1.default.isBoolean(submitFlag)) {
            this.alreadySubmitFlag = true;
            //提出済みの場合はそれ以外のエラーフラグをfalseにしてエラーメッセージを抑制する
            this.defaultErrorFlag = false;
            this.approvedFlag = false;
        }
        var approvedFlag = this.$route.query.approvedFlag;
        if (approvedFlag && value_checker_1.default.isBoolean(approvedFlag)) {
            this.alreadySubmitFlag = false;
            this.defaultErrorFlag = false;
            this.approvedFlag = true;
        }
    };
    EkycHoujinProxyTop = __decorate([
        vue_property_decorator_1.Component({
            components: { Loading: Loading_1.default, ErrorPanel: ErrorPanel_1.default }
        })
    ], EkycHoujinProxyTop);
    return EkycHoujinProxyTop;
}(vue_property_decorator_1.Vue));
exports.default = EkycHoujinProxyTop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/contract_form/EkycHoujinProxyTop.vue
// module id = Fz/+
// module chunks = 1